import { Model } from '@vuex-orm/core';

class Device extends Model {
  static entity = 'devices';

  static fields() {
    return {
      deviceId: this.attr(null),
      battery: this.attr(null),
      isPlugged: this.attr(null),
      user: this.attr(null),
      updatedAt: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchByGroupName(group) {
        return this.get(`groups/${group}/devices`);
      },
    },
  }
}

export default Device;
